var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "homehd",
      class: _vm.isShow ? "" : "hedden_div",
      staticStyle: { background: "#e8faf1" },
    },
    [
      _c("panel-group", { attrs: { "total-data": _vm.totalData } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pl-10 pr-10 mb-5" },
        [
          _c(
            "el-row",
            { attrs: { gutter: _vm.device === "mobile" ? 0 : 5 } },
            [
              _c("el-col", { staticClass: "mb-3", attrs: { md: 21, lg: 12 } }, [
                _c(
                  "div",
                  { staticClass: "p-20 bg-white" },
                  [_c("pie-chart", { ref: "pieChart" })],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("el-col", { staticClass: "mb-5", attrs: { md: 24, lg: 12 } }, [
                _c(
                  "div",
                  { staticClass: "p-20 bg-white" },
                  [
                    _c("device-type", {
                      ref: "deviceType",
                      attrs: { platList: _vm.platList },
                      on: {
                        switchType: _vm.pieSwitchType,
                        switchPlat: _vm.pieSwitchPlat,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pl-10 pr-10 mb-5" },
        [
          _c(
            "el-row",
            { attrs: { gutter: _vm.device === "mobile" ? 0 : 5 } },
            [
              _c("el-col", { staticClass: "mb-5", attrs: { md: 24, lg: 24 } }, [
                _c("div", { staticClass: "p-20 bg-white" }, [
                  _c("div", { staticClass: "tit mb-15 " }, [
                    _c("span", { staticClass: "lin" }),
                    _c("b", { staticClass: "fs-a1" }, [_vm._v("设备地图")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "rel" },
                    [
                      _c("maps", {
                        ref: "map_box",
                        attrs: {
                          center: { lat: 33.272016, lng: 105.801051 },
                          "is-edit": false,
                          zooms: 4,
                          height: "397px",
                        },
                        on: { setShopInfo: _vm.setShopInfo },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "abs el-icon-full-screen cursor",
                        on: { click: _vm.setMapScreen },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "z-99 abs map-data_content" }, [
                        _vm.shopInfo.id > 0
                          ? _c(
                              "div",
                              { staticClass: "p-10 fs-s3 map-data_box" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "mb-5 f-w text-primary" },
                                  [_vm._v("商户详情：")]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c("div", [
                                    _vm._v(
                                      "商户ID：" + _vm._s(_vm.shopInfo.id)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "商户名称：" +
                                        _vm._s(_vm.shopInfo.store_name)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "手机号码：" + _vm._s(_vm.shopInfo.mobile)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "地址：" + _vm._s(_vm.shopInfo.address)
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mt-10" },
                                  _vm._l(
                                    _vm.shopInfo.device_type_arr,
                                    function (item) {
                                      return item.has_num > 0
                                        ? _c("div", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item.depend_name) +
                                                "：" +
                                                _vm._s(item.has_num)
                                            ),
                                          ])
                                        : _vm._e()
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pl-10 pr-10 mb-5" },
        [_c("todo", { attrs: { "stat-money": _vm.statMoney } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "el-notification",
          class: { "notification-show": _vm.informStatus },
        },
        [
          _c("div", { staticStyle: { width: "100%" } }, [
            _c("h2", { staticClass: "el-notification__title" }, [
              _vm._v("服务通知"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pt-5 el-notification__content fs-s3" },
              [
                _vm._l(_vm.informList, function (item) {
                  return [
                    item.num > 0 && item.content
                      ? _c(
                          "div",
                          {
                            staticClass: "mt-5 flex text-cut cursor",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({ path: item.url })
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "title text-primary" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pr-10 flex1 text-cut" }, [
                              _vm._v(_vm._s(item.content)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "p-5",
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  plain: "",
                                  round: "",
                                },
                              },
                              [_vm._v("去处理")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "el-notification__closeBtn el-icon-close",
              on: {
                click: function ($event) {
                  _vm.informStatus = false
                  _vm.$store.dispatch("rests/changeSetting", {
                    key: "informClose",
                    value: true,
                  })
                },
              },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "el-notification operation-log-notification",
          class: { "notification-show": _vm.operationLogStatus },
        },
        [
          _c("div", { staticStyle: { width: "100%" } }, [
            _c("h2", { staticClass: "el-notification__title" }, [
              _vm._v("平台操作日志提醒"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pt-5 el-notification__content fs-s3" },
              [
                _vm._l(_vm.operationLogList, function (item) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "mt-5 flex text-cut cursor",
                        on: { click: _vm.goToOperationLogPage },
                      },
                      [
                        _c("div", { staticClass: "title text-primary" }, [
                          _vm._v(_vm._s(item.operation_option)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pr-10 flex1 text-cut" }, [
                          _vm._v(
                            _vm._s(item.user_nick_name) +
                              " - " +
                              _vm._s(item.content)
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "p-5",
                            attrs: {
                              type: "primary",
                              size: "mini",
                              plain: "",
                              round: "",
                            },
                          },
                          [_vm._v("查看")]
                        ),
                      ],
                      1
                    ),
                  ]
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "el-notification__closeBtn el-icon-close",
              on: { click: _vm.closeOperationLogNotify },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "version-container" }, [
      _c("div", { staticClass: "version-info" }, [
        _c("span", { staticClass: "version-text" }, [_vm._v("Version")]),
        _vm._v(" "),
        _c("span", { staticClass: "version-number" }, [_vm._v("4.3.7")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }